export const rootPaths = {
  dashboard: "branch/:bId/dashboard",
  signin: "signin",
  selectBranch: "select-branch",
  admin: "admin",
} as const;

export const buildDashBoardPath = (bId: string) => `/branch/${bId}/dashboard`;
